import { css } from 'linaria';

export namespace Styles {
  export const animatedSnack = css`
    animation-fill-mode: forwards;

    @keyframes appearDisappear {
      from {
        opacity: 0;
      }
      8% {
        opacity: 1;
      }
      78% {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }

    @keyframes appearance {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `;

  export const withApearDisapearAnimation = css`
    animation: appearDisappear 3600ms ease;
  `;

  export const withAppearanceOnlyAnimation = css`
    animation: appearance 200ms ease;
  `;

  export const alertIcon = css`
    width: 20px;
    height: 20px;

    fill: var(--contol-invert, currentColor);
  `;
}
